import { render, staticRenderFns } from "./codeList.vue?vue&type=template&id=896a1048&scoped=true&"
import script from "./codeList.vue?vue&type=script&lang=js&"
export * from "./codeList.vue?vue&type=script&lang=js&"
import style0 from "./codeList.vue?vue&type=style&index=0&id=896a1048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896a1048",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('896a1048')) {
      api.createRecord('896a1048', component.options)
    } else {
      api.reload('896a1048', component.options)
    }
    module.hot.accept("./codeList.vue?vue&type=template&id=896a1048&scoped=true&", function () {
      api.rerender('896a1048', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DesignEditor/component/modular/codeList.vue"
export default component.exports